import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getSentenceListApiCall = createAsyncThunk("sentenceList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: sentenceList } = await API.getSentenceListApi(submitData);
        //  console.log("*********************************************",sentenceList);
        dispatch(setLoader(false))
        return sentenceList;
    } catch (error) {
        throw error;
    }
});

export const editSentenceDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editSentenceData, code, message } = await API.updateSentenceApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editSentenceData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    sentenceList: {
        data: [],
        error: null,
    },
    editSentenceData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const sentenceSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSentenceListApiCall.fulfilled, (state, action) => {
                state.sentenceList.data = action.payload;
            })
            .addCase(getSentenceListApiCall.rejected, (state, action) => {
                state.sentenceList.error = action.error.message;
            })
            .addCase(editSentenceDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editSentenceData.data = data;
                state.editSentenceData.message = message;
                state.editSentenceData.code = code;
            })
            .addCase(editSentenceDataApiCall.rejected, (state, action) => {
                state.editSentenceData.error = action.error.message;
            });
    },
});

export default sentenceSlice.reducer;